exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ag-side-button {\n\t background-color: #fc0 50;\n\t color: red;\n\t font-weight: 900;\n}\n", ""]);

// exports
